/*
 * Correct the way to get userData.GTM_ID, userData.GTM_AUTH, userData.GTM_PREVIEW
 */

import { initializeGTM } from '@/core/data/events/handlers/gtm';
import { Settings } from '@/data/Settings';
import { GA_VERSION_GA4, GA_VERSION_UA } from '@/data/constants/gtm';

export const getGTMConfig = (settings: Settings) => {
	const { userData = {} } = settings ?? {};
	const versions = (userData.GA_VERSIONS ?? '').split(',');
	const gtmId = userData.GTM_ID;
	// const gtmId = 'GTM-NWVB337C'; // For testing purpose only
	const gtmAuth = userData.GTM_AUTH;
	const gtmPreview = userData.GTM_PREVIEW;
	const ga4 = !!versions.find((version) => version === GA_VERSION_GA4);
	const ua = !!versions.find((version) => version === GA_VERSION_UA);
	if (!ga4 && !ua) {
		// default to GA if no version is specified
		return { ga4: true, ua: false, gtmId, gtmAuth, gtmPreview };
	}
	return { ga4, ua, gtmId, gtmAuth, gtmPreview };
};

export { initializeGTM };
